/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from 'react';
import PropTypes from "prop-types";
import {FILTER_TYPES} from "../../../../data/finders.model";
import {closeFinderPanel, resetAllFilters} from "../../../../actions/finder";
import {connect} from "react-redux";
import Block from "../../../atoms/layout/Block";
import Link from "../../../atoms/text/Link";
import SidepanelCheckboxesPanel from "./SidepanelCheckboxesPanel";
import {makeTagsMapper} from "../../../../selectors/tags";
import {getSelectedTags, hasFiltering} from "../../../../selectors/finder";
import {TagType} from "../../../../data/aem.model";
import ListCheckboxesPanel from "./ListCheckboxesPanel";
import {ShowHide} from "../../../atoms/layout/ShowHide";
import {TextColors} from "../../../../config/styles";
import {withI18N} from "../../../hoc/withI18N";
import {compose} from "redux";

class FilterPanel extends React.Component {

    static propTypes = {
        panel: PropTypes.any.isRequired,
        selected: PropTypes.arrayOf(PropTypes.shape(TagType)).isRequired,
        closeFinderPanel: PropTypes.func,
        toggleFilters: PropTypes.func,
        hasFiltering: PropTypes.bool,
        resetAllFilters: PropTypes.func,
        resource: PropTypes.object
    };

    constructor(props) {
        super(props);

        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    handleClickOutside(event) {
        const path = event.path || (event.composedPath && event.composedPath());

        // If click on the panel itself
        if (this.wrapperRef && this.wrapperRef.contains(event.target)) {
            return;
        }

        // If click inside of the current expanded panel's filter
        if (path.map(path => path && path.classList).filter(cls => cls).findIndex(classes => classes.contains("finder__filter") && classes.contains("expanded")) > -1) {
            return;
        }

        if (path.findIndex(path => path.classList && path.classList.contains("filter-sidepanel_checkboxes-button")) > -1) {
            return;
        }

        this.props.closeFinderPanel();
    }

    renderPanel = () => {
        switch (this.props.panel.type) {
            case FILTER_TYPES.EXCLUSIVE_CHECKBOXES_FILTER:
            case FILTER_TYPES.DEFAULT_CHECKBOXES_FILTER:
                return <ListCheckboxesPanel resource={this.props.resource} filter={this.props.panel} selected={this.props.selected} />;
            case FILTER_TYPES.SIDEPANEL_CHECKBOXES_FILTER:
                return <SidepanelCheckboxesPanel resource={this.props.resource} filter={this.props.panel} selected={this.props.selected} />;
            default:
                return null;
        }
    };

    render() {
        const { panel, closeFinderPanel, toggleFilters, hasFiltering, resetAllFilters, translate } = this.props;

        return (<div className="p-filter-container__aside-panel" ref={this.setWrapperRef}>
                <Block className={"sticky-sidebar"}>
                    <Block className="p-filter-container__aside-panel-header">
                        <Link onClick={closeFinderPanel} className={"desktop-hidden p-filter-container__aside-panel-header-go-back flex-ignored-size"}>
                            <span className="svg-arrow-left"/>
                        </Link>
                        <span className="p-filter-container__aside-panel-title">
                            {panel.type === FILTER_TYPES.SIDEPANEL_CHECKBOXES_FILTER ? panel.panelTitle : panel.childTagTitle}
                        </span>
                        <span className="svg-cross close-button desktop-visible" onClick={closeFinderPanel}/>
                        <span className="flex-ignored-size desktop-hidden"/>
                    </Block>
                    <Block className="p-filter-container__aside-panel-body">
                        <span className="svg-cross close-button p-margin-left-auto desktop-hidden" onClick={closeFinderPanel}/>
                        {this.renderPanel()}
                    </Block>
                    <Block className={"desktop-hidden p-filter-container__aside-panel-mobile-actions"}>
                        <Link className="btn-primary"
                              onClick={toggleFilters} text={translate("Apply")} />

                        <ShowHide show={hasFiltering}>
                            <Link onClick={resetAllFilters} className="btn-secondary"
                                  text={translate("Reset")} color={TextColors.red} />
                        </ShowHide>
                    </Block>
                </Block>
            </div>)
    }

}


const mapStateToProps = () => {
    const selectedTagsSelector = makeTagsMapper((state, ownProps) => getSelectedTags(state, ownProps.panel.index));

    return (state, ownProps) => ({
        hasFiltering: hasFiltering(state),
        selected: selectedTagsSelector(state, ownProps)
    });
};

export default compose(withI18N, connect(mapStateToProps, {
    closeFinderPanel,
    resetAllFilters
}))(FilterPanel);
